import React from 'react'
import UpdateCCForm from '../../../component/form/vehicle-managment/cc/UpdateCCForm'

export default function UpdateCC() {
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout_head'>
                            <h5>Update CC</h5>
                            <UpdateCCForm />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}